class ProteinCalculator {
  constructor(element) {
    this.element = element;
    this.currentStep = 1;
    this.totalSteps = 6;
    this.data = {};
    this.googleSheetsId = '1fah5wV1JCNVGd6mE9WhyaAt9NeTLfMlusFC0B4H9GG4';

    this.init();
  }

  init() {
    this.bindEvents();
    this.showStep(this.currentStep);
  }

  bindEvents() {
    this.element.querySelector('.protein-calculator__age-block__next-btn').addEventListener('click', () => {
      if (this.validateAge()) {
        this.saveAge();
        this.nextStep();
      }
    });

    this.element.querySelector('.protein-calculator__gender-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.element.querySelector('.protein-calculator__gender-block__next-btn').addEventListener('click', () => {
      if (this.validateGender()) {
        this.saveGender();
        this.nextStep();
      }
    });

    this.element.querySelector('.protein-calculator__height-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.element.querySelector('.protein-calculator__height-block__next-btn').addEventListener('click', () => {
      if (this.validateHeight()) {
        this.saveHeight();
        this.nextStep();
      }
    });

    this.element.querySelector('.protein-calculator__weight-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.element.querySelector('.protein-calculator__weight-block__next-btn').addEventListener('click', () => {
      if (this.validateWeight()) {
        this.saveWeight();
        this.nextStep();
      }
    });

    this.element.querySelector('.protein-calculator__goal-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.element.querySelector('.protein-calculator__goal-block__next-btn').addEventListener('click', () => {
      if (this.validateGoal()) {
        this.saveGoal();
        this.nextStep();
      }
    });

    this.element.querySelector('.protein-calculator__activity-block__prev-btn').addEventListener('click', () => {
      this.prevStep();
    });
    this.element.querySelector('.protein-calculator__activity-block__next-btn').addEventListener('click', () => {
      if (this.validateActivity()) {
        this.saveActivity();
        this.calculateProtein();
        this.nextStep();
      }
    });

    this.element.querySelector('.protein-calculator__email-block__submit-btn').addEventListener('click', () => {
      if (this.validateEmail()) {
        this.saveEmail();
        this.submitToGoogleSheets();
      }
    });

    this.element.querySelector('.protein-calculator__reset-button').addEventListener('click', () => {
      this.reset();
    });

    this.element.querySelector('.protein-calculator__close').addEventListener('click', () => {
      this.close();
    });
  }

  showStep(step) {
    const blocks = this.element.querySelectorAll(
      '.protein-calculator__age-block, .protein-calculator__gender-block, .protein-calculator__height-block, .protein-calculator__weight-block, .protein-calculator__goal-block, .protein-calculator__activity-block, .protein-calculator__email-block, .protein-calculator__result-block'
    );
    blocks.forEach((block) => {
      block.classList.remove('active');
    });

    setTimeout(() => {
      let currentBlock;
      switch (step) {
        case 1:
          currentBlock = this.element.querySelector('.protein-calculator__age-block');
          break;
        case 2:
          currentBlock = this.element.querySelector('.protein-calculator__gender-block');
          break;
        case 3:
          currentBlock = this.element.querySelector('.protein-calculator__height-block');
          break;
        case 4:
          currentBlock = this.element.querySelector('.protein-calculator__weight-block');
          break;
        case 5:
          currentBlock = this.element.querySelector('.protein-calculator__goal-block');
          break;
        case 6:
          currentBlock = this.element.querySelector('.protein-calculator__activity-block');
          break;
        case 7:
          currentBlock = this.element.querySelector('.protein-calculator__email-block');
          break;
        case 8:
          currentBlock = this.element.querySelector('.protein-calculator__result-block');
          break;
      }
      if (currentBlock) {
        currentBlock.classList.add('active');
      }
    }, 100);
  }

  nextStep() {
    if (this.currentStep < this.totalSteps + 2) {
      this.currentStep++;
      this.showStep(this.currentStep);
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.showStep(this.currentStep);
    }
  }

  validateAge() {
    const age = this.element.querySelector('.protein-calculator__age-block__input').value;
    const errorMsg = this.element.querySelector('.protein-calculator__age-block .error-message');

    if (!age || age < 1 || age > 120) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateGender() {
    const gender = this.element.querySelector('input[name="gender"]:checked');
    const errorMsg = this.element.querySelector('.protein-calculator__gender-block .error-message');

    if (!gender) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateHeight() {
    const height = this.element.querySelector('.protein-calculator__height-block__input').value;
    const errorMsg = this.element.querySelector('.protein-calculator__height-block .error-message');

    if (!height || height < 100 || height > 250) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateWeight() {
    const weight = this.element.querySelector('.protein-calculator__weight-block__input').value;
    const errorMsg = this.element.querySelector('.protein-calculator__weight-block .error-message');

    if (!weight || weight < 30 || weight > 300) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateGoal() {
    const goal = this.element.querySelector('input[name="goal"]:checked');
    const errorMsg = this.element.querySelector('.protein-calculator__goal-block .error-message');

    if (!goal) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateActivity() {
    const activity = this.element.querySelector('input[name="activity"]:checked');
    const errorMsg = this.element.querySelector('.protein-calculator__activity-block .error-message');

    if (!activity) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  validateEmail() {
    const email = this.element.querySelector('.protein-calculator__email-block__input').value;
    const errorMsg = this.element.querySelector('.protein-calculator__email-block .error-message');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email)) {
      errorMsg.style.display = 'block';
      return false;
    }
    errorMsg.style.display = 'none';
    return true;
  }

  saveAge() {
    this.data.age = this.element.querySelector('.protein-calculator__age-block__input').value;
  }

  saveGender() {
    this.data.gender = this.element.querySelector('input[name="gender"]:checked').value;
  }

  saveHeight() {
    this.data.height = this.element.querySelector('.protein-calculator__height-block__input').value;
  }

  saveWeight() {
    this.data.weight = this.element.querySelector('.protein-calculator__weight-block__input').value;
  }

  saveGoal() {
    this.data.goal = this.element.querySelector('input[name="goal"]:checked').value;
  }

  saveActivity() {
    this.data.activity = this.element.querySelector('input[name="activity"]:checked').value;
  }

  saveEmail() {
    this.data.email = this.element.querySelector('.protein-calculator__email-block__input').value;
  }

  calculateProtein() {
    const weight = parseFloat(this.data.weight);
    const dailyProtein = Math.round(weight * 0.8);
    this.data.result = dailyProtein;
  }

  updateResultsDisplay() {
    const resultElement = this.element.querySelector('.protein-calculator__result-block__result');
    if (resultElement) {
      resultElement.textContent = this.data.result + 'gm of protein per day';
    }
  }

  getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2);
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  }

  showSuccessMessage() {
    this.updateResultsDisplay();
    this.showStep(8);
  }

  async submitToGoogleSheets() {
    const submitBtn = this.element.querySelector('.protein-calculator__email-block__submit-btn button');
    const submitBtnLoading = this.element.querySelector('.protein-calculator__email-block__submit-btn--loading');
    const errorMsg = this.element.querySelector('.protein-calculator__email-block .error-message');

    // Show loading state
    submitBtn.classList.add('hidden');
    submitBtnLoading.classList.remove('hidden');
    submitBtn.disabled = true;
    this.element.classList.add('loading');

    try {
      const formData = {
        Timestamp: this.getCurrentTimestamp(),
        Email: this.data.email,
        Age: this.data.age,
        Gender: this.data.gender,
        Height: this.data.height,
        Weight: this.data.weight,
        Goal: this.data.goal,
        Activity: this.data.activity,
        DailyProtein: this.data.result
      };

      const scriptUrl = `https://script.google.com/macros/s/AKfycby5ZD6IOJk7WJ_3DcZjT3hVcti-6mk5umgUAjYaR8y4LB5tdS9wHclsVANG2EOii-SpbQ/exec`;

      await fetch(scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          spreadsheetId: this.googleSheetsId,
          data: formData,
        }),
      });
      errorMsg.style.display = 'none';

      this.showSuccessMessage();
    } catch (error) {
      console.error('Error submitting to Google Sheets:', error);
      errorMsg.textContent = 'Failed to submit. Please try again.';
      errorMsg.style.display = 'block';
      submitBtnLoading.classList.add('hidden');
      submitBtn.classList.remove('hidden');
      submitBtn.disabled = false;
    }

    this.element.classList.remove('loading');
  }

  open() {
    this.element.classList.add('active');
  }

  close() {
    this.element.classList.remove('active');
  }

  reset() {
    this.currentStep = 1;
    this.data = {};

    this.element.querySelector('.protein-calculator__age-block__input').value = '';

    // Reset gender to default (male)
    this.element.querySelectorAll('input[name="gender"]').forEach((input) => {
      input.checked = input.value === 'male';
    });

    this.element.querySelector('.protein-calculator__height-block__input').value = '';
    this.element.querySelector('.protein-calculator__weight-block__input').value = '';

    // Reset goal to default (lose_weight)
    this.element.querySelectorAll('input[name="goal"]').forEach((input) => {
      input.checked = input.value === 'lose_weight';
    });

    // Reset activity to default (sedentary)
    this.element.querySelectorAll('input[name="activity"]').forEach((input) => {
      input.checked = input.value === 'sedentary';
    });

    const emailInput = this.element.querySelector('.protein-calculator__email-block__input');
    if (emailInput) emailInput.value = '';
    this.element.querySelector('.protein-calculator__result-block__result').textContent = '';

    this.element.querySelectorAll('.error-message').forEach((msg) => (msg.style.display = 'none'));

    const submitBtn = this.element.querySelector('.protein-calculator__email-block__submit-btn button');
    const submitBtnLoading = this.element.querySelector('.protein-calculator__email-block__submit-btn--loading');
    if (submitBtn && submitBtnLoading) {
      submitBtn.classList.remove('hidden');
      submitBtnLoading.classList.add('hidden');
      submitBtn.disabled = false;
    }

    this.showStep(1);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const calculatorElement = document.querySelector('protein-calculator');
  const openButton = document.querySelector('.protein-calculator__open');

  if (calculatorElement) {
    const calculator = new ProteinCalculator(calculatorElement);

    if (openButton) {
      openButton.addEventListener('click', () => {
        calculator.open();
      });
    }
  }
});
